// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Avatar-Img-module--cls1--2zfxy","cls2":"Avatar-Img-module--cls2--3odW0 Avatar-Img-module--cls1--2zfxy"};